import { useRef, useState } from "react";
import { Film, Link2, X } from "lucide-react";
import { toast } from "sonner";
import { errMsg, uploadVideo } from "@/lib/api";

export const VideoAttach = ({ value, onChange }) => {
  const ref = useRef(null);
  const [mode, setMode] = useState(null);
  const [progress, setProgress] = useState(null);

  const pick = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    if (file.size > 100 * 1024 * 1024) {
      toast.error("Video is too large (max 100 MB). Try a YouTube link instead.");
      return;
    }
    setProgress(0);
    try {
      onChange(await uploadVideo(file, setProgress));
      setMode(null);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setProgress(null);
    }
  };

  if (value) {
    return (
      <div className="flex items-center gap-2 text-sm bg-[var(--hb-lime-soft)] rounded-full pl-3 pr-1 py-1" data-testid="composer-video-attached">
        <Film size={14} /> {value.startsWith("/api/files/") ? "Video uploaded" : "Video link added"}
        <button type="button" onClick={() => onChange("")} className="w-6 h-6 rounded-full bg-[var(--hb-ink)] text-white grid place-items-center" data-testid="composer-video-remove">
          <X size={12} />
        </button>
      </div>
    );
  }
  if (progress !== null) {
    return <span className="btn-ghost" data-testid="composer-video-progress">Uploading video... {progress}%</span>;
  }
  if (mode === "link") {
    return <LinkInput onDone={(url) => { onChange(url); setMode(null); }} onCancel={() => setMode(null)} />;
  }
  return (
    <>
      <input ref={ref} type="file" accept="video/mp4,video/quicktime,video/webm" className="hidden" onChange={pick} data-testid="composer-video-file-input" />
      <button type="button" className="btn-ghost" onClick={() => ref.current?.click()} data-testid="composer-video-upload"><Film size={13} /> Video</button>
      <button type="button" className="btn-ghost" onClick={() => setMode("link")} data-testid="composer-video-link"><Link2 size={13} /> Video link</button>
    </>
  );
};

const LinkInput = ({ onDone, onCancel }) => {
  const [url, setUrl] = useState("");
  return (
    <div className="flex gap-2 w-full">
      <input className="hb-input !py-2" placeholder="Paste YouTube or Vimeo link" value={url} autoFocus
        onChange={(e) => setUrl(e.target.value)} data-testid="composer-video-link-input" />
      <button type="button" className="btn-dark" disabled={!url.trim()} onClick={() => onDone(url.trim())} data-testid="composer-video-link-add">Add</button>
      <button type="button" className="btn-ghost" onClick={onCancel}>Cancel</button>
    </div>
  );
};
